import { Component, OnInit, OnDestroy,AfterViewInit,Renderer2 ,ViewEncapsulation} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { I18Service } from '../../../services/i18Service';
import { BaseService, LayoutService } from '../../../../shared';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../services/auth.service';
declare var $: any;
import { HttpClient } from '@angular/common/http';



@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy,AfterViewInit {
    private subscriptions: Subscription[] = [];
    userData: any;
    currentDate = new Date();
    lang = this.baseService.currentLang || localStorage.getItem('lang') || 'ar';
    searchInput:string='';
    showSearch = true;
    activeColor = 'defaultMode';
    themeName = 'night-theme';
    // loginUrl = environment.EntitiesFrontIdentity.Login;
    constructor(private http: HttpClient,private translate: TranslateService,
        private renderer: Renderer2,private route: ActivatedRoute,
        private baseService: BaseService, public router: Router,
        private authService : AuthService
    ) {     this.translate.use(this.lang);


        this.userData = this.authService.getUserInfo();
        this.themeName = localStorage.getItem('themeNameNew') || 'night-theme';
        this.activeColor = localStorage.getItem('activeColor') || 'defaultMode';
        const dom: any = document.querySelector('body');
        dom.classList.add(this.themeName);
        if(this.activeColor.length > 0){
            dom.classList.add(this.activeColor);

        }


    }
    temperature;
    iconUrl;
    getTemperature() {
       // const url = 'https://api.openweathermap.org/data/2.5/weather?lat=24.67&lon=46.69&appid=ac1dc1e0f58f857ece592a91f453b8a0&units=metric';
        const url = 'https://api.openweathermap.org/data/2.5/weather?q=Riyadh,SA&appid=9b0d77403031cf5adc71f7d316196294&units=metric';
        this.http.get(url).subscribe(data => {
            
          this.temperature = data;
         this.iconUrl = this.temperature.weather[0].icon;
        });
      }
    ngOnInit(): void {





        //this.GetMenuList();
        this.getTemperature();

        this.authService.userInfo.subscribe(res => {
            if(res)
            this.userData=res
        })

        $('.fa-cog').click(function(event) {
            event.stopPropagation();
            $(".color").fadeIn("");
            $(".fa-cog").fadeOut();
            $(".fa-times").fadeIn("");
        });
        $(".fa-times").click(function() {
            $(".color").fadeOut("");
        });
        $(".color").on("click", function(event) {

            event.stopPropagation();

        });





    }




    menuList = [];
    // GetMenuList() {
    //     let subscription = this.baseService.post("menus/GetMenus", { ReferenceId: environment.ReferenceId, Code: environment.EntitesCode.Home.code_MenuHeader })
    //         .subscribe({
    //             next: (res: any) => {

    //                 this.menuList = res.output.MenusEntity.subMenus;
    //                 localStorage.setItem('menu',res.output.MenusEntity.id)

    //             }
    //             , error: (error: string) => {
    //                  ;
    //             }
    //         });
    //     this.subscriptions.push(subscription);
    // }



    viewContent(item){
        if(item.url && item.url.length > 0)
        { this.router.navigate([item.url]);}        }
    ngOnDestroy(): void {
        for (let subscription of this.subscriptions) {
          subscription.unsubscribe();
        }
      }


      goOutSidt(url){
        window.open(url, '_blank')
      }

      ngAfterViewInit(): void {
        $('.icon .bottom').click(function() {
            $('body').addClass("active");
            $(".searchpop").fadeIn("");
        });
        $('.exit').click(function() {
            $('body').removeClass("active");
            $(".searchpop").fadeOut("");
        });

        $('.filterby').click(function() {
            $('.item-inner,body').addClass('active');
            $(".bgoverlay").fadeIn("");
        });

        $('.clos-filter').click(function() {
            $(".item-inner,body").removeClass("active");
            $(".bgoverlay").fadeOut("");
        });


        $('.bgoverlay').click(function() {
            $("body,.item-inner").removeClass("active");
            $(".bgoverlay").fadeOut("");
        });

        const toggleMenu = () => {
            // navbarMenu.classList.toggle("active");
            // overlayMenu.classList.toggle("active");
        };
        const collapseSubMenu = () => {
            navbarMenu
                .querySelector(".menu-dropdown.active .submenu")
                .removeAttribute("style");
            navbarMenu.querySelector(".menu-dropdown.active").classList.remove("active");
        };

        // Toggle Mobile Submenu Function
        const toggleSubMenu = (e) => {
            if (e.target.hasAttribute("data-toggle") && window.innerWidth <= 991) {
                e.preventDefault();
                const menuDropdown = e.target.parentElement;

                // If Dropdown is Expanded, then Collapse It
                if (menuDropdown.classList.contains("active")) {
                    collapseSubMenu();
                } else {
                    // Collapse Existing Expanded Dropdown
                    if (navbarMenu.querySelector(".menu-dropdown.active")) {
                        collapseSubMenu();
                    }

                    // Expanded the New Dropdown
                    menuDropdown.classList.add("active");
                    const subMenu = menuDropdown.querySelector(".submenu");
                    subMenu.style.maxHeight = subMenu.scrollHeight + "px";
                }
            }
        };
        const resizeWindow = () => {
            // if (window.innerWidth > 991) {
            //     if (navbarMenu.classList.contains("active")) {
            //         toggleMenu();
            //     }
            //     if (navbarMenu.querySelector(".menu-dropdown.active")) {
            //         collapseSubMenu();
            //     }
            // }
        };
        const navbarMenu = document.getElementById("navbar");
        const overlayMenu = document.querySelector(".overlay");
      //  overlayMenu.addEventListener("click", toggleMenu);
        //navbarMenu.addEventListener("click", toggleSubMenu);
        window.addEventListener("resize", resizeWindow);





    //     $('.fa-cog').click(function(event) {
    //         event.stopPropagation();
    //         $(".color").fadeIn("");
    //         $(".fa-cog").fadeOut();
    //         $(".fa-times").fadeIn("");
    //     });
    //     $(".fa-times").click(function() {
    //         $(".color").fadeOut("");
    //     });
    //     $(".color").on("click", function(event) {

    //         event.stopPropagation();

    //     });

    // $(document).on("click", function() {
    //     $(".color").fadeOut("");
    //     $(".fa-times").fadeOut("");
    //     $(".fa-cog").fadeIn();
    // });




      }

      changeStyle(className) {

        this.themeName = className;

        const dom: any = document.querySelector('body');
        dom.classList.toggle('night-theme');
        localStorage.setItem('themeNameNew', className);
        this.changeTheame('defaultMode');

    }
    todayDates(){
        const today = new Date();

    }

    logOut(){
        localStorage.removeItem('userInfo');
        localStorage.removeItem('token');
        this.baseService.post('users/GenerateToken',{}).subscribe(res => {
        if(res.output){
            this.userData=null;
            localStorage.setItem('token',res.output.UserJWT);
            this.router.navigate(['/'])
        }
       });
    }
    checkUrlValue(url){
        if(url){
            return url;
        }
    }


    closeSearch(){
        this.showSearch = false;
        this.searchInput = '';
    }
    submit(){
        let searchInput= document.getElementsByName('searchInput')
        this.router.navigate([this.lang,'advancedSearch',this.searchInput])
        this.closeSearch();

    }



    weaterIcon = {
        '01d':'clear_day',
        '02d':'partly_cloudy_day',
        '03d':'cloudy',
        '04d':'cloudy',
        '09d':'rainy',
        '10d':'rainy',
        '11d':'thunderstorm',
        '13d':'weather_snowy',
        '50d':'foggy',


        '01n':'clear_night',
        '02n':'partly_cloudy_night',
        '03n':'cloudy',
        '04n':'cloudy',
        '09n':'rainy',
        '10n':'rainy',
        '11n':'thunderstorm',
        '13n':'weather_snowy',
        '50n':'foggy',
    }

    changeTheame(className){
        this.activeColor = className;
        const cssClasses = ['invertColor','grayColor','defaultMode']
        localStorage.removeItem('activeColor');

        cssClasses.forEach(element => {
            this.renderer.removeClass(document.body, element);

        });
        if(className.length > 0){
            this.renderer.addClass(document.body, className);
            localStorage.setItem('activeColor', className);


        }
    }
    changeLang(){

        const urlTree = this.router.parseUrl(this.router.url);
        const segments = urlTree.root.children.primary.segments;
        const currentLang = this.baseService.currentLang;
        const newLang = currentLang == 'ar'? 'en' : 'ar';
        const NewUrl =  this.router.url.replace(currentLang, newLang);
        const dom: any = document.querySelector('body');
        dom.classList.toggle('rtl');
        dom.classList.toggle('english');
        localStorage.setItem('lang', newLang);
        this.translate.use(newLang);
        this.baseService.setLanData({ lang: newLang });
        this.lang = newLang;


        this.router.navigateByUrl(NewUrl);

    }
    openMobilrMenu(elements,subMenuList?){
        elements.forEach(element => {
          element.classList.toggle('active')
        });
   }
}







